<template>
  <div class="is-size-4 content is-custom has-text-black-bis">
    <div
      class="card"
      :class="{
        'mt-24px': $media.mobile,
        'mt-32px': $media.tablet,
        'mt-40px': $media.widescreen
      }"
    >
      <ui-box>
        <prismic-rich-text :field="prismicContent.welcome_message" />
      </ui-box>
    </div>
  </div>
</template>

<script>
import UiBox from '@/components/ui/box'
export default {
  components: {
    UiBox
  },
  props: {
    prismicContent: {
      Type: Object
    }
  }
}
</script>